import { useEffect, useState } from 'react';
import usePlatformConfig from '../../common/react/usePlatformConfig';
import useWidgetContext from '../../common/react/useWidgetContext';
import locale from '../../common/service/locale';
import useCustomizeCarContext from './useCustomizeCarContext';

const useInterestRate: () => string = () => {
  const { selectedCar } = useCustomizeCarContext();
  const [interestRate, setInterestRate] = useState<string>('0');
  const interestRateDecimalScale = usePlatformConfig().platformConfig.priceDisplay.finance?.interestRateDecimalScale;
  const { language, country } = useWidgetContext().configuration.dimensions;

  useEffect(() => {
    if (selectedCar?.finance?.simulation?.interestRate) {
      let rate: number | string = selectedCar.finance.simulation.interestRate;

      if (interestRateDecimalScale) {
        rate = new Intl.NumberFormat(locale.getLocaleCode(language, country), {
          minimumFractionDigits: interestRateDecimalScale,
          maximumFractionDigits: interestRateDecimalScale,
        }).format(rate);
      }

      setInterestRate(rate.toString());
    }
  }, [selectedCar]);

  return interestRate;
};

export default useInterestRate;
